import {
	type MetaFunction,
	type LoaderFunctionArgs,
	redirect,
} from '@remix-run/node'
import { Link } from '@remix-run/react'
import { Button } from '#app/components/ui/button.tsx'
import { getUserId } from '#app/utils/auth.server.ts'

export const loader = async ({ request }: LoaderFunctionArgs) => {
	const userId = await getUserId(request)
	if (userId) {
		return redirect('/materiality')
	}
	return null
}

export const meta: MetaFunction = () => [
	{ title: 'Double Materiality Navigator' },
]

export default function Index() {
	return (
		<main className="relative min-h-screen bg-gradient-to-b from-background to-muted">
			<div className="container flex min-h-screen flex-col items-center justify-center gap-8 px-4 py-16 sm:px-6 lg:px-8">
				<div className="flex flex-col items-center gap-6 text-center">
					<div className="space-y-2">
						<h1 className="text-4xl font-bold tracking-tighter sm:text-5xl md:text-6xl">
							Welcome to Double Materiality Navigator
						</h1>
						<p className="mx-auto max-w-[600px] text-muted-foreground md:text-xl">
							Your comprehensive platform for assessing and managing
							sustainability impacts and financial materiality.
						</p>
					</div>
					<div className="flex flex-col gap-4 sm:flex-row">
						<Button asChild size="lg" variant="default">
							<Link to="/login">Log In</Link>
						</Button>
						<Button asChild size="lg" variant="outline">
							<Link to="/signup">Create Account</Link>
						</Button>
					</div>
				</div>
				<div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
					<div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
						<h3 className="text-lg font-semibold">Impact Assessment</h3>
						<p className="mt-2 text-sm text-muted-foreground">
							Evaluate your organization's environmental and social impacts with
							our comprehensive assessment tools.
						</p>
					</div>
					<div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
						<h3 className="text-lg font-semibold">Financial Materiality</h3>
						<p className="mt-2 text-sm text-muted-foreground">
							Analyze how sustainability factors affect your financial
							performance and risk profile.
						</p>
					</div>
					<div className="rounded-lg border bg-card p-6 text-card-foreground shadow-sm">
						<h3 className="text-lg font-semibold">Strategic Insights</h3>
						<p className="mt-2 text-sm text-muted-foreground">
							Get actionable insights to improve your sustainability strategy
							and business performance.
						</p>
					</div>
				</div>
			</div>
		</main>
	)
}
